var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C6CF3",
    d: "M13 25.715v-25M.5 13.215h25"
  })));
};

export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjEyLjk5OTgiIHkxPSIyNS43MTQ4IiB4Mj0iMTIuOTk5OCIgeTI9IjAuNzE0ODQ0IiBzdHJva2U9IiMwQzZDRjMiLz4KPGxpbmUgeDE9IjAuNDk5NzU2IiB5MT0iMTMuMjE0OCIgeDI9IjI1LjQ5OTgiIHkyPSIxMy4yMTQ4IiBzdHJva2U9IiMwQzZDRjMiLz4KPC9zdmc+Cg==";